import React from 'react'
import Sectiontitle from '../section-title'
import strory1 from '../../images/events/1.jpg'
import strory2 from '../../images/events/2.jpg'
import strory3 from '../../images/events/3.jpg'
// import LocationMap from '../LocationModal/LocationModal'
import useScreenSize from '../../hook/responsive';

import './style.css'

const Location = () => {
    const isMobile = useScreenSize();
    return (


        <div id="event" className="service-area section-padding">
            <div className="container">
                <Sectiontitle section={'When & Where'} />
                <div className="service-area-menu">
                    <div className="Ceremony-wrap">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="ceromony-img">
                                    <img src={strory1} alt="" />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="ceromony-content">
                                    <h3>Wedding Ceremony</h3>
                                    <span>4.00 PM-5.00 PM</span>
                                    <p>Join us at the Grand Walawwa to share your love with us as we exchange rings and take your blessings.</p>
                                    {/* <LocationMap buttonClass={'location-btn'} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Ceremony-wrap">
                    {isMobile && <div className="row">
                        <div className="col-lg-5">
                            <div className="ceromony-img">
                                <img src={strory2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="ceromony-content ceromony-content2">
                                <h3>Wedding Party</h3>
                                <span>5.00 PM-11.30 PM</span>
                                <p>Join us at The Grand Walawwa - Glass Hall, have a great time celebrating with us!</p>
                                {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                    </div>}
                    {!isMobile && <div className="row">
                        <div className="col-lg-7">
                            <div className="ceromony-content ceromony-content2">
                                <h3>Wedding Party</h3>
                                <span>5.00 PM-11.30 PM</span>
                                <p>Join us at The Grand Walawwa - Glass Hall, have a great time celebrating with us!</p>
                                {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="ceromony-img">
                                <img src={strory2} alt="" />
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="Ceremony-wrap">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="ceromony-img">
                                <img src={strory3} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="ceromony-content">
                                <h3>When the Night Ends</h3>
                                <span>11.30 PM</span>
                                <p>As the night comes to a close, we’ll bid you farewell with hearts full of joy and gratitude for sharing this special day with us.</p>
                                {/* <LocationMap buttonClass={'location-btn'} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Location;